import { deleteApi, getApi, postApi, putApi } from "./_apihelper";

export const AddProjects = (data) =>
  postApi(
    process.env.REACT_APP_PROJECT,
    data,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const EditProjects = (id, data) =>
  putApi(
    `${process.env.REACT_APP_PROJECT}/${id}`,
    data,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const GetProjects = (payload) =>
  getApi(
    `${process.env.REACT_APP_PROJECT}?limit=${payload.limit}&offset=${payload.offset}&keyword=${payload?.keyword}&isActive=${payload.isActive}`,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const GetProjectById = (id) =>
  getApi(
    `${process.env.REACT_APP_PROJECT}/${id}`,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const GetProjectJobById = (projectId, jobId) =>
  getApi(
    `${process.env.REACT_APP_JOB_POSTINGS}/project/${projectId}/job/${jobId}`,
    process.env.REACT_APP_JOBOPENING,
  );

export const GetProjectsComments = (data) =>
  getApi(
    `${process.env.REACT_APP_PROJECTS_COMMENTS}?type=${data.type}&typeId=${data.typeId}`,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const GetAccessibleTo = (id) =>
  getApi(
    `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/${id}/getuserbyroles`,
    process.env.REACT_APP_USE_MANAGEMENT,
  );

export const GetProjectApplicants = (obj) => {
  if (obj?.keyword) {
    return getApi(
      `${process.env.REACT_APP_PROJECT}/${obj.id}/projectapplicants?limit=${obj.limit}&offset=${obj.offset}&keyword=${obj.keyword}`,
      process.env.REACT_APP_PROJECTS_URL,
    );
  } else {
    return getApi(
      `${process.env.REACT_APP_PROJECT}/${obj.id}/projectapplicants?limit=${obj.limit}&offset=${obj.offset}`,
      process.env.REACT_APP_PROJECTS_URL,
    );
  }
};

export const AddAssociateProjectApplicants = (data) =>
  postApi(
    process.env.REACT_APP_PROJECT_ASSOCIATEAPPLICANTS,
    data,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const DeleteProjectApplicants = (data) =>
  deleteApi(
    process.env.REACT_APP_PROJECT_APPLICANTS,
    data,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const DeleteProjectJobs = (data) =>
  deleteApi(
    process.env.REACT_APP_PROJECT_JOBS,
    data,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const UpdateProjectJobStatus = (projectId, data) =>
  putApi(
    `${process.env.REACT_APP_PROJECT}/${projectId}/projectjobs`,
    data,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const GetProjectJobs = (obj) => {
  if (obj?.keyword) {
    return getApi(
      `${process.env.REACT_APP_JOB_POSTINGS}?keyword=${obj.keyword}&projectId=${obj.id}`,
      process.env.REACT_APP_JOBOPENING,
    );
  } else {
    return getApi(
      `${process.env.REACT_APP_JOB_POSTINGS}?projectId=${obj.id}`,
      process.env.REACT_APP_JOBOPENING,
    );
  }
};

export const AddAssociateProjectJobs = (data) =>
  postApi(
    `${process.env.REACT_APP_PROJECT}/associateprojectjobs`,
    data,
    process.env.REACT_APP_PROJECTS_URL,
  );

export const GetProjectsByApplicantId = (id) =>
  getApi(
    `${process.env.REACT_APP_PROJECT}/applicant/${id}`,
    process.env.REACT_APP_PROJECTS_URL,
  );

  export const GetProjectsByJobPostingId = (id) =>
  getApi(
    `${process.env.REACT_APP_PROJECT}/jobid/${id}`,
    process.env.REACT_APP_PROJECTS_URL,
  );
